// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    font-family: 'Segoe UI', Roboto, Arial, sans-serif;
    background: #f4f7fa;
    color: #222;
    margin: 0;
    padding: 0;
}
.container {
    max-width: 900px;
    margin: 40px auto;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 4px 24px rgba(0,0,0,0.08);
    padding: 32px 24px 40px 24px;
}
.summary-box {
    background: #e6fffa;
    color: #222;
    border-radius: 10px;
    padding: 28px 32px 22px 32px;
    margin-bottom: 32px;
    box-shadow: 0 2px 12px rgba(66,153,225,0.08);
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.summary-text {
    font-size: 1.25em;
    font-weight: 500;
    line-height: 1.5;
    max-width: 70%;
}
.percent-circle {
    background: #fff;
    color: #4299e1;
    border-radius: 50%;
    width: 90px;
    height: 90px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 2.2em;
    font-weight: bold;
    box-shadow: 0 2px 10px rgba(0,0,0,0.10);
    border: 4px solid #4299e1;
}
.attachments-title {
    font-size: 1.5em;
    font-weight: 600;
    margin: 24px 0 16px 0;
    color: #2b6cb0;
    letter-spacing: 0.5px;
}
.attachment-list {
    list-style: none;
    padding: 0;
    margin: 0;
}
.attachment-item {
    background: #f7fafc;
    border-radius: 8px;
    margin-bottom: 12px;
    box-shadow: 0 1px 4px rgba(0,0,0,0.04);
    transition: box-shadow 0.2s;
}
.attachment-header {
    display: flex;
    align-items: center;
    cursor: pointer;
    padding: 18px 20px;
    font-size: 1.08em;
    font-weight: 500;
    border-radius: 8px;
    transition: background 0.15s;
}
.attachment-header:hover {
    background: #e2e8f0;
}
.status-icon {
    font-size: 1.5em;
    margin-right: 18px;
    width: 1.5em;
    text-align: center;
}
.attachment-details {
    display: none;
    padding: 0 28px 18px 58px;
    color: #444;
    font-size: 1em;
}
.attachment-item.open .attachment-details {
    display: block;
    animation: fadeIn 0.3s;
}
@keyframes fadeIn {
    from { opacity: 0; transform: translateY(-10px); }
    to { opacity: 1; transform: translateY(0); }
}
.status-provided { color: #38a169; }
.status-missing { color: #e53e3e; }
.status-notrequired { color: #319795; }
@media print {
    .attachment-header { pointer-events: none; }
    .attachment-details { display: block !important; }
}`, "",{"version":3,"sources":["webpack://./src/styles/initial_report.css"],"names":[],"mappings":"AAAA;IACI,kDAAkD;IAClD,mBAAmB;IACnB,WAAW;IACX,SAAS;IACT,UAAU;AACd;AACA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,uCAAuC;IACvC,4BAA4B;AAChC;AACA;IACI,mBAAmB;IACnB,WAAW;IACX,mBAAmB;IACnB,4BAA4B;IAC5B,mBAAmB;IACnB,4CAA4C;IAC5C,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;AACA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,iBAAiB;IACjB,uCAAuC;IACvC,yBAAyB;AAC7B;AACA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,qBAAqB;IACrB,cAAc;IACd,qBAAqB;AACzB;AACA;IACI,gBAAgB;IAChB,UAAU;IACV,SAAS;AACb;AACA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,sCAAsC;IACtC,2BAA2B;AAC/B;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,4BAA4B;AAChC;AACA;IACI,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,yBAAyB;IACzB,WAAW;IACX,cAAc;AAClB;AACA;IACI,cAAc;IACd,sBAAsB;AAC1B;AACA;IACI,OAAO,UAAU,EAAE,4BAA4B,EAAE;IACjD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC/C;AACA,mBAAmB,cAAc,EAAE;AACnC,kBAAkB,cAAc,EAAE;AAClC,sBAAsB,cAAc,EAAE;AACtC;IACI,qBAAqB,oBAAoB,EAAE;IAC3C,sBAAsB,yBAAyB,EAAE;AACrD","sourcesContent":["body {\n    font-family: 'Segoe UI', Roboto, Arial, sans-serif;\n    background: #f4f7fa;\n    color: #222;\n    margin: 0;\n    padding: 0;\n}\n.container {\n    max-width: 900px;\n    margin: 40px auto;\n    background: #fff;\n    border-radius: 12px;\n    box-shadow: 0 4px 24px rgba(0,0,0,0.08);\n    padding: 32px 24px 40px 24px;\n}\n.summary-box {\n    background: #e6fffa;\n    color: #222;\n    border-radius: 10px;\n    padding: 28px 32px 22px 32px;\n    margin-bottom: 32px;\n    box-shadow: 0 2px 12px rgba(66,153,225,0.08);\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n.summary-text {\n    font-size: 1.25em;\n    font-weight: 500;\n    line-height: 1.5;\n    max-width: 70%;\n}\n.percent-circle {\n    background: #fff;\n    color: #4299e1;\n    border-radius: 50%;\n    width: 90px;\n    height: 90px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 2.2em;\n    font-weight: bold;\n    box-shadow: 0 2px 10px rgba(0,0,0,0.10);\n    border: 4px solid #4299e1;\n}\n.attachments-title {\n    font-size: 1.5em;\n    font-weight: 600;\n    margin: 24px 0 16px 0;\n    color: #2b6cb0;\n    letter-spacing: 0.5px;\n}\n.attachment-list {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n}\n.attachment-item {\n    background: #f7fafc;\n    border-radius: 8px;\n    margin-bottom: 12px;\n    box-shadow: 0 1px 4px rgba(0,0,0,0.04);\n    transition: box-shadow 0.2s;\n}\n.attachment-header {\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n    padding: 18px 20px;\n    font-size: 1.08em;\n    font-weight: 500;\n    border-radius: 8px;\n    transition: background 0.15s;\n}\n.attachment-header:hover {\n    background: #e2e8f0;\n}\n.status-icon {\n    font-size: 1.5em;\n    margin-right: 18px;\n    width: 1.5em;\n    text-align: center;\n}\n.attachment-details {\n    display: none;\n    padding: 0 28px 18px 58px;\n    color: #444;\n    font-size: 1em;\n}\n.attachment-item.open .attachment-details {\n    display: block;\n    animation: fadeIn 0.3s;\n}\n@keyframes fadeIn {\n    from { opacity: 0; transform: translateY(-10px); }\n    to { opacity: 1; transform: translateY(0); }\n}\n.status-provided { color: #38a169; }\n.status-missing { color: #e53e3e; }\n.status-notrequired { color: #319795; }\n@media print {\n    .attachment-header { pointer-events: none; }\n    .attachment-details { display: block !important; }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
